type TagBadge = {
  id: string;
  name: string;
};

type TagBadgesProps = {
  tags?: TagBadge[];
  tone: string;
  onSelect?: (tag: TagBadge) => void;
};

export default function TagBadges({ tags = [], tone, onSelect }: TagBadgesProps) {
  const style = { color: tone, '--tag-tone': tone } as any;
  return (
    <>
      {tags.map((tag) => onSelect ? (
        <button
          type="button"
          className="detail-tag"
          style={style}
          key={tag.id}
          onClick={() => onSelect(tag)}
        >
          {tag.name}
        </button>
      ) : (
        <span className="detail-tag" style={style} key={tag.id}>
          {tag.name}
        </span>
      ))}
    </>
  );
}
